package component

import com.github.quillraven.fleks.*

class StateComponent : Component<StateComponent> {

    var state = STATE_NORMAL

    override fun type() = StateComponent

    companion object : ComponentType<StateComponent>() {
        const val STATE_NORMAL = 0
        const val STATE_JUMPING = 1
        const val STATE_FALLING = 2
        const val STATE_MOVING = 3
        const val STATE_ON_WALL = 4
        const val STATE_HIT = 5

        fun stateToText(state: Int): String {
            return when (state) {
                STATE_NORMAL -> "STATE_NORMAL"
                STATE_JUMPING -> "STATE_JUMPING"
                STATE_FALLING -> "STATE_FALLING"
                STATE_MOVING -> "STATE_MOVING"
                STATE_ON_WALL -> "STATE_ON_WALL"
                STATE_HIT -> "STATE_HIT"
                else -> ""
            }
        }
    }
}
